import { Flex, Img, Link, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";

export function FootMobile() {
  const router = useRouter();
  const verifyPage = router.route;

  return (
    <Flex flexDir={"column"} w={"full"} letterSpacing={"-1px"}>
      <Flex flexDirection="column" height="full" width="100%" p="20px" bgColor="ll-gray.600">
        <Flex
          direction="column"
          borderBottomWidth="1px"
          borderBottomColor="#58585A"
          borderBottomStyle="dashed"
          py={"10px"}
          mb={"15px"}
        >
          <Text fontSize={"h3"} color={"ll-blue.main"} fontWeight={"600"}>
            Vendas
          </Text>
          <Text fontSize={"text1"} color={"ll-green.main"} mb={"15px"}>
            (dias úteis das 8h às 18h)
          </Text>
          <Link display="flex" mb="10px" href="tel:+5504140421100" isExternal>
            <Img
              src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
              mr="10px"
              width="21px"
              height="21px"
              alt="Phone Vendas"
            />
            <Text fontSize={"text1"} color="ll-gray.300">
              <Text>(41) 4042-1100</Text>
            </Text>
          </Link>
          <Link
            fontSize="text1"
            _hover={{ textDecoration: "none" }}
            display="flex"
            href="mailto:sac@linglong.com.br"
            isExternal
          >
            <Img
              src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
              mr="10px"
              width="21px"
              height="21px"
              alt="Email vendas"
            />
            <Text textStyle="Regular" fontSize="text1" color="ll-gray.300">
              sac@linglong.com.br
            </Text>
          </Link>
        </Flex>

        <Flex
          direction="column"
          borderBottomWidth="1px"
          borderBottomColor="#58585A"
          borderBottomStyle="dashed"
          py={"10px"}
          mb={"15px"}
        >
          <Text fontSize={"h3"} color={"ll-blue.main"} fontWeight={"600"}>
            Pós-vendas
          </Text>
          <Text fontSize={"text1"} color={"ll-green.main"} mb={"15px"}>
            (dias úteis das 8h às 18h)
          </Text>
          <Link
            fontSize="text1"
            _hover={{ textDecoration: "none" }}
            color="gray.50"
            display="flex"
            mb="10px"
            textStyle="Regular"
            href="tel:+5504140421212"
            isExternal
            //passHref
          >
            <Img
              src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
              mr="10px"
              width="21px"
              height="21px"
              alt="Phone Pós Vendas"
            />
            <Text fontSize="text1" color="ll-gray.300">
              <Text>(41) 4042-1212</Text>
            </Text>
          </Link>
          <Link
            fontSize="text1"
            _hover={{ textDecoration: "none" }}
            color="gray.50"
            display="flex"
            href="mailto:sac@lingLong.com.br"
            isExternal
            //passHref
          >
            <Img
              src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
              mr="10px"
              width="21px"
              height="21px"
              alt="Email vendas"
            />
            <Text textStyle="Regular" fontSize="text1" color="ll-gray.300">
              sac@linglong.com.br
            </Text>
          </Link>
        </Flex>

        <Flex
          direction="column"
          borderBottomWidth="1px"
          borderBottomColor="#58585A"
          borderBottomStyle="dashed"
          py={"10px"}
          mb={"15px"}
        >
          <Flex direction="column">
            <Text fontSize={"h3"} color={"ll-blue.main"} fontWeight={"600"} mb={"10px"}>
              Links Úteis
            </Text>
            <Link href="/ajuda/sobre" _hover={{ textDecoration: "none" }} mb="5px" fontSize="text1">
              Quem somos
            </Link>
            <Link href="/ajuda" _hover={{ textDecoration: "none" }} mb="5px" fontSize="text1">
              Central de ajuda
            </Link>
            <Link
              href="/ajuda/privacidade-linglong"
              _hover={{ textDecoration: "none" }}
              mb="5px"
              fontSize="text1"
            >
              Política de privacidade
            </Link>

            <Link
              href="/ajuda/contato-linglong"
              _hover={{ textDecoration: "none" }}
              mb="5px"
              fontSize="text1"
            >
              Fale conosco
            </Link>
          </Flex>
        </Flex>

        <Flex direction="column" alignItems="stast" mt="20px">
          <Img
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ling-long-logo.svg"}
            width="270px"
            mb="10px"
            alt="Logo LingLong"
          />
          <Img
            src="https://cdn.pneufree.com.br/LINGLONG/images/Geral/loja-segura.svg"
            width="164px"
            height="51px"
            mb="2rem"
            mt="1rem"
            alt={"Loja Segura"}
          />
        </Flex>
      </Flex>
      <Flex
        justifyContent={"center"}
        alignContent={"center"}
        w="full"
        h={"auto"}
        py={"10px"}
        background={"linear-gradient(99.09deg, #0C4EA2 14.48%, #00A550 90.81%);"}
      >
        <Text
          textAlign={"center"}
          maxW={"95%"}
          letterSpacing={"0px"}
          color={"ll-white.main"}
          fontSize={"11px"}
        >
          Loja Oficial LingLong Pneus operada por: Pneufree.com Brasil Ltda
          CNPJ: 11.891.896/0001-62 - R. Dep. Heitor Alencar Furtado, 3350 - 6º andar - 81200-528 -
          Curitiba - PR
        </Text>
      </Flex>
    </Flex>
  );
}
